<p-dialog [(visible)]="showDeleteEmployee" [closeOnEscape]="false" [showHeader]="false" [modal]="true" [draggable]="false" [style]="{width: '600px'}">
    <div *ngIf="!employeeIsDeleted">
        <img src="../Content/xpress-app/images/person_question.svg" style="display: block; margin: 0 auto; " />
        <div class="partner-employees-dialog-header">Delete this employee?</div>
        <div class="partner-employees-dialog-description">Are you sure to delete this employee? The employee’s Information will be remove in the system too.<br>This cannot be undone</div>
        <div class="flex flex-row">
            <button [disabled]="loading" (click)="handleHideDeleteUserDialog()" label="No" class="outlined-dark-blue-btn" pButton style="width: 137px; height: 45px; margin-right: 13px; margin-left: auto"></button>
            <button [disabled]="loading" (click)="deleteMerchantUser()" class="red-btn" pButton label="Yes, Delete" style="width: 137px; height: 45px; margin-right: auto;"></button>
        </div>
    </div>
    <div *ngIf="employeeIsDeleted">
        <div style="margin-top: 50px;" class="partner-employees-dialog-header">Employee deleted successfully</div>
        <div style="text-align:center">
            <button style="margin: 25px auto; width: 273px; height: 45px;" class="bluedark-btn" pButton label="Ok" (click)="handleHideDeleteUserDialog()"></button>
        </div>
    </div>
</p-dialog>